import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';

const LoaderComponent: React.FC = () => {
 
  return (
    <Box sx={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1300,
      background: 'rgba(185, 183, 183, 0.49)'
    }}>
      <CircularProgress size={80} thickness={5} />
    </Box>
  );
};

export default LoaderComponent;
